import instance from './instance';
import auth from '../../auth';

export default class API {
  constructor() {
    this.axios = instance();
  }

  get(query, showLoader = false) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${auth.token.get()}`
      },
      showLoader,
    };
    const apiUrl = '/';
    const promise = new Promise((resolve, reject) => {
      this.axios.post(apiUrl, query, config)
        .then((response) => {
          const { data } = response;

          if (!data || data.errors) {
            return reject(data.errors);
          }

          return resolve(data);
        })
        .catch(errors => reject(errors));
    });

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/request/api/index.js